import { SearchHistoryType } from "@/enums/SearchHistoryType";
import ApiResponseV2 from "@/external/ensolvers-core-frontend-mui-v5/submodules/fox-typescript/core/ApiResponseV2";
import HttpClientV2 from "@/external/ensolvers-core-frontend-mui-v5/submodules/fox-typescript/utils/HttpClientV2";
import { SearchHistory } from "@/models/SearchHistory";

class SearchHistoryService {
  private path: string;
  constructor(path: string) {
    this.path = path;
  }

  getByUserAndType(type: SearchHistoryType): Promise<ApiResponseV2<SearchHistory[]>> {
    return HttpClientV2.get(`${this.path}/user?type=${type}`);
  }

  save(dto: SearchHistory): Promise<ApiResponseV2<SearchHistory>> {
    return HttpClientV2.post(`${this.path}`, dto);
  }
}

export default new SearchHistoryService("/api/search-history");
